/*
 * product-addons.js  —  Schacht Groves Citrus
 * Shows/hides the add-on rows rendered by blocks/product-addons.liquid when the
 * customer changes size, and exposes window.SchachtAddons.collect(form) so
 * assets/product-form.js can add the ticked add-ons to the cart with the main item.
 */
(function () {
  'use strict';

  if (window.SchachtAddons) return;

  function containersFor(scope) {
    return (scope || document).querySelectorAll('[data-product-addons]');
  }

  function isEligible(row, variantId) {
    var eligible = row.dataset.eligible || '';
    return eligible === '*' || eligible.split(',').indexOf(String(variantId)) !== -1;
  }

  // SKU-matched add-ons (e.g. gift boxes) have one version per product size: point the
  // checkbox at the version for this size and show its price.
  function applyVariantMap(row, variantId) {
    if (!row.dataset.variantMap) return;
    var map;
    try { map = JSON.parse(row.dataset.variantMap); } catch (e) { return; }
    var entry = map[String(variantId)];
    if (!entry) return;
    var checkbox = row.querySelector('input[type="checkbox"]');
    if (checkbox) checkbox.dataset.variantId = String(entry.id);
    var price = row.querySelector('.product-addons__price');
    if (price && entry.price) price.textContent = '+' + entry.price;
  }

  function update(container, variantId) {
    var anyVisible = false;
    container.querySelectorAll('[data-addon-row]').forEach(function (row) {
      var ok = variantId != null && isEligible(row, variantId);
      row.hidden = !ok;
      if (ok) applyVariantMap(row, variantId);
      if (!ok) {
        var checkbox = row.querySelector('input[type="checkbox"]');
        if (checkbox) checkbox.checked = false;
      }
      if (ok) anyVisible = true;
    });
    container.hidden = !anyVisible;
  }

  // Add-ons in the same choice group are pick-one (e.g. one gift box per tray).
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!(input instanceof HTMLInputElement) || input.type !== 'checkbox' || !input.checked) return;
    var row = input.closest('[data-addon-row][data-group]');
    var container = row && row.closest('[data-product-addons]');
    if (!container) return;
    container.querySelectorAll('[data-addon-row][data-group]').forEach(function (other) {
      if (other === row || other.dataset.group !== row.dataset.group) return;
      var checkbox = other.querySelector('input[type="checkbox"]');
      if (checkbox) checkbox.checked = false;
    });
  });

  // Horizon fires `variant:update` (ThemeEvents.variantUpdate) with the new variant in
  // event.detail.resource. Listen in the capture phase so we see it whether or not it bubbles.
  document.addEventListener(
    'variant:update',
    function (event) {
      var detail = event.detail || {};
      var variant = detail.resource;
      var productId = detail.data && detail.data.productId;
      var target = event.target instanceof Element ? event.target : null;
      var scope = (target && target.closest('.shopify-section, dialog, product-card')) || document;
      containersFor(scope).forEach(function (container) {
        if (productId && container.dataset.productId && String(productId) !== container.dataset.productId) return;
        update(container, variant ? variant.id : null);
      });
    },
    true
  );

  // Picking an add-on size updates that row's price and ticks the add-on.
  document.addEventListener('change', function (event) {
    var select = event.target;
    if (!(select instanceof HTMLSelectElement) || !select.hasAttribute('data-addon-variant-select')) return;
    var row = select.closest('[data-addon-row]');
    if (!row) return;
    var option = select.options[select.selectedIndex];
    var price = row.querySelector('.product-addons__price');
    if (price && option && option.dataset.price) price.textContent = '+' + option.dataset.price;
    var checkbox = row.querySelector('input[type="checkbox"]');
    if (checkbox) checkbox.checked = true;
  });

  window.SchachtAddons = {
    /**
     * Ticked, currently-eligible add-ons for a product form.
     * @param {HTMLFormElement} form
     * @returns {{ id: number }[]}
     */
    collect: function (form) {
      // Not form.id: the product form has an input named "id", which shadows the property.
      var formId = form && form.getAttribute('id');
      if (!formId) return [];
      var picked = [];
      document
        .querySelectorAll('[data-product-addons][data-form-id="' + formId + '"]')
        .forEach(function (container) {
          if (container.hidden) return;
          container.querySelectorAll('[data-addon-row]').forEach(function (row) {
            if (row.hidden) return;
            var checkbox = row.querySelector('input[type="checkbox"]');
            if (!checkbox || !checkbox.checked) return;
            var select = row.querySelector('[data-addon-variant-select]');
            var id = Number(select ? select.value : checkbox.dataset.variantId);
            if (id) picked.push({ id: id });
          });
        });
      return picked;
    },
  };
})();
